import type { TaskState } from '@app/types/tasks'

import type { Task } from '@app/packages/task/Task'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

/** Task gets converted to TaskState on serialization */
const tasksSlice = createReduxSlice<{ [key: string]: Task<any, any> | TaskState }>('tasks')

export const getTaskSlice = (label: string) => createThunk(dispatch => dispatch(tasksSlice.get())?.[label])

export const setTaskSlice = (label: string, task: Task<any, any>) => tasksSlice.update(state => ({ ...state, [label]: task }))
